export default __webpack_public_path__ + "static/media/rock-soldiers.1a00b451.jpg";